import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'
import en from './i18n/en'

// App is English-only. No language detection or switching.
i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: { en },
  });

// Recipe titles come from the API as multilingual objects {en, no, lt}.
// Always return the English version, falling back to the raw value.
const translatedTitle = (title) => {
  if (typeof title === 'string') return title;
  if (title['en'] === '') return '';
  return title['en'] || title;
}

export { translatedTitle };

export default i18n;
